import styles from "./BlogCategoryButton.module.css";

function BlogCategoryToggle({ className, onClick }) {
  return (
    <button
      type="button"
      className={`${className} ${styles.button}`}
      onClick={onClick}
    >
      Categories
    </button>
  );
}

export default BlogCategoryToggle;
